import React from 'react';

/** Lazy ClientComputedMetadataSelection (not wrapped in a suspense to use the parent widget loading fallback) */
export const ClientComputedMetadataSelection = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'widget-metadata-selection' */
            './ConnectedClientComputedMetadataSelection'
        ),
);
